import { render, staticRenderFns } from "./CorporationConfig.vue?vue&type=template&id=49c9abb0&scoped=true"
import script from "./CorporationConfig.vue?vue&type=script&lang=js"
export * from "./CorporationConfig.vue?vue&type=script&lang=js"
import style0 from "./CorporationConfig.vue?vue&type=style&index=0&id=49c9abb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9abb0",
  null
  
)

export default component.exports